import React from 'react';
import { Link } from 'react-router-dom';
import './AboutTilak.css';



const CRED_CARDS = [
  { icon: '🎓', title: 'NIT Kurukshetra', sub: 'MCA' },
  { icon: '🏛️', title: 'Family Lineage', sub: '3+ Generations' },
  { icon: '⭐', title: '1000+', sub: 'Predictions Delivered' },
];

const AboutTilak = () => {
  const sectionStyle = {
    '--at-chakra-img': `url("${process.env.PUBLIC_URL}/images/legacy/chakra-ring.png")`,
  };
  return (
  <section className="at" id="about-tilak" style={sectionStyle} aria-label="About Tilak, founder of VTD Astrology">
    <div className="at__inner">

      {/* ── LEFT: Photo + credentials ── */}
      <div className="at__left">
        <div className="at__photo-wrap">
          <div className="at__photo-ring" aria-hidden="true" />
          <div className="at__photo">
            <img
              src="/images/tilak.jpg"
              alt="Tilak, Founder of VTD Astrology"
              className="at__photo-img"
            />
          </div>
        </div>

        <div className="at__founder-badge">
          <span className="at__founder-role">Founder &amp; CEO</span>
          <span className="at__founder-org">VTD Astrology</span>
        </div>

        <div className="at__cred-cards">
          {CRED_CARDS.map((c) => (
            <div key={c.title} className="at__cred-card">
              <span className="at__cred-icon" aria-hidden="true">{c.icon}</span>
              <span className="at__cred-title">{c.title}</span>
              <span className="at__cred-sub">{c.sub}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── RIGHT: Story ── */}
      <div className="at__right">
        <p className="at__eyebrow">Meet the Founder</p>
        <h2 className="at__heading">I am Tilak</h2>
        <p className="at__subheading">Astrologer &nbsp;·&nbsp; Remedy Expert &nbsp;·&nbsp; CEO of VTD Astrology</p>
        <div className="gold-divider" style={{ margin: '1.25rem 0' }} />

        <p className="at__para">
          I walked away from NIT Kurukshetra during my MCA to follow a calling that was stronger
          than any degree — the ancient science of Vedic astrology. That was not a dropout.
          That was a decision.
        </p>

        <p className="at__para">
          My father Chandramouli is an expert in Tantrik and Mantra Shastra. My forefathers have
          been in this sacred field for generations. Astrology is not something I learned from
          books alone — it runs in my blood.
        </p>

        <p className="at__para">
          I am not a random guru with generic predictions. I am a practical astrologer with a
          scientific approach. I combine ancient Vedic wisdom with modern analytical thinking to
          give you accurate, specific, and actionable insights about your life.
        </p>

        <blockquote className="at__quote">
          <p className="at__quote-text">
            "Every remedy I prescribe is personally crafted for your unique planetary situation.
            I do not delegate this to anyone. Your problem reaches me directly — and my focus is
            to change your life through spirituality and practical remedies."
          </p>
          <footer className="at__quote-author">— Tilak, Founder VTD Astrology</footer>
        </blockquote>

        <p className="at__para">
          VTD Astrology — Vision Towards Destiny — was built to make authentic Vedic guidance
          accessible to everyone. Not per-minute billing. Not random astrologers.
          Just honest, accurate, life-changing predictions.
        </p>

        <div className="at__btns">
          <a href="/chat" className="at__btn at__btn--wa">
            <WAIcon /> Chat with Tilak →
          </a>
          <Link to="/about" className="at__btn at__btn--outline">
            Read Our Story →
          </Link>
        </div>
      </div>

    </div>
  </section>
  );
};

const WAIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default AboutTilak;
